var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.6719C10.5304 10.6719 11.0391 10.4612 11.4142 10.0861C11.7893 9.71102 12 9.20231 12 8.67188C12 8.14144 11.7893 7.63273 11.4142 7.25766C11.0391 6.88259 10.5304 6.67188 10 6.67188C9.46957 6.67188 8.96086 6.88259 8.58579 7.25766C8.21071 7.63273 8 8.14144 8 8.67188C8 9.20231 8.21071 9.71102 8.58579 10.0861C8.96086 10.4612 9.46957 10.6719 10 10.6719Z",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13281 14.5012C6.30894 13.9687 6.6485 13.5052 7.10319 13.1768C7.55789 12.8484 8.10457 12.6717 8.66548 12.6719H11.3321C11.8927 12.6717 12.439 12.8482 12.8936 13.1762C13.3481 13.5042 13.6877 13.9672 13.8641 14.4992",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 6.18233C15.7167 6.44766 16.0033 6.94433 16 7.481V12.337C16 12.8763 15.7047 13.3737 15.228 13.6357L10.728 16.4823C10.5049 16.6048 10.2545 16.669 10 16.669C9.74549 16.669 9.4951 16.6048 9.272 16.4823L4.772 13.6357C4.53878 13.5082 4.34408 13.3204 4.20827 13.092C4.07247 12.8635 4.00053 12.6028 4 12.337V7.48033C4 6.941 4.29533 6.44433 4.772 6.18233L9.272 3.529C9.50169 3.40235 9.75971 3.33594 10.022 3.33594C10.2843 3.33594 10.5423 3.40235 10.772 3.529L15.272 6.18233H15.25Z",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/Client.cacf56c90eb3c3ef37ca029d3942a999.svg";
export { ForwardRef as ReactComponent };